import React, { useEffect, useMemo, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  MagnifyingGlassIcon,
  MapPinIcon,
  UserIcon,
  PhoneIcon,
  EnvelopeIcon,
  BuildingOffice2Icon,
  XMarkIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/solid";

import {
  fetchGeolocation,
  fetchSuggestions,
  fetchLocationOptions,
  searchUsers,
  clearSelectedUser,
  setSelectedUser,
  setManualLocation,
} from "../../redux/commonsharing/Searchcomponentbuser";

import UserCard from "../../Pages/UserCard";

// ============================================================
// COLORS
// ============================================================

const CUSTOM_GRADIENT =
  "linear-gradient(145deg, rgb(15, 31, 51) 0%, rgb(26, 58, 92) 50%, rgb(30, 73, 118) 100%)";

const BUTTON_GRADIENT =
  "linear-gradient(135deg, rgb(26, 58, 92), rgb(14, 165, 233))";

const PRIMARY_DARK = "rgb(26, 58, 92)";

const PRIMARY_BLUE = "rgb(14, 165, 233)";

const PRIMARY_LIGHT = "rgb(239, 246, 255)";

const BORDER_COLOR = "rgb(219, 234, 254)";

const TEXT_DARK = "rgb(51, 65, 85)";

const TEXT_MUTED = "rgb(100, 116, 139)";

// ============================================================
// COMPONENT
// ============================================================

const SearchBar = () => {
  const dispatch = useDispatch();

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  // ==========================================================
  // REDUX STATE
  // ==========================================================

  const businessUserSearch = useSelector(
    (state) => state.businessUserSearch || {},
  );

  const {
    country,
    postcode,
    postalCode,
    pincode,
    pinCode,
    fullAddress,
    city,
    village,
    area,
    locality,
    district,
    state,
    lat,
    lon,
    suggestions: reduxSuggestions,
    selectedUser,
    locationOptions,
  } = businessUserSearch;

  // ==========================================================
  // FETCH USER CURRENT LOCATION
  // ==========================================================

  useEffect(() => {
    console.log("========================================");

    console.log("📍 STARTING USER GEOLOCATION...");

    console.log("========================================");

    dispatch(fetchGeolocation())
      .unwrap()
      .then((location) => {
        console.log("========================================");

        console.log("📍 USER CURRENT LOCATION");

        console.log("========================================");

        console.log("Latitude:", location?.lat);

        console.log("Longitude:", location?.lon);

        console.log("Country:", location?.country);

        console.log("State:", location?.state);

        console.log("District:", location?.district);

        console.log("City:", location?.city);

        console.log("Village:", location?.village);

        console.log(
          "Pincode:",
          location?.postcode ||
            location?.postalCode ||
            location?.pincode ||
            location?.pinCode ||
            "",
        );

        console.log("Full Address:", location?.fullAddress);

        console.log("Raw Address:", location?.rawAddress);

        console.log("📦 COMPLETE LOCATION OBJECT:", location);

        console.log("========================================");
      })
      .catch((error) => {
        console.error("❌ USER GEOLOCATION ERROR:", error);
      });
  }, [dispatch]);

  // ==========================================================
  // DEBUG REDUX LOCATION STATE
  // ==========================================================

  // useEffect(() => {
  //   const currentPincode =
  //     postcode ||
  //     postalCode ||
  //     pincode ||
  //     pinCode ||
  //     "";

  //   console.log(
  //     "========================================"
  //   );

  //   console.log(
  //     "📍 CURRENT SEARCH LOCATION STATE"
  //   );

  //   console.log(
  //     "========================================"
  //   );

  //   console.log(
  //     "Country   :",
  //     country
  //   );

  //   console.log(
  //     "State     :",
  //     state
  //   );

  //   console.log(
  //     "District  :",
  //     district
  //   );

  //   console.log(
  //     "City      :",
  //     city
  //   );

  //   console.log(
  //     "Village   :",
  //     village
  //   );

  //   console.log(
  //     "Area      :",
  //     area
  //   );

  //   console.log(
  //     "Locality  :",
  //     locality
  //   );

  //   console.log(
  //     "Pincode   :",
  //     currentPincode
  //   );

  //   console.log(
  //     "Latitude  :",
  //     lat
  //   );

  //   console.log(
  //     "Longitude :",
  //     lon
  //   );

  //   console.log(
  //     "Address   :",
  //     fullAddress
  //   );

  //   console.log(
  //     "========================================"
  //   );
  // }, [
  //   country,
  //   state,
  //   district,
  //   city,
  //   village,
  //   area,
  //   locality,
  //   postcode,
  //   postalCode,
  //   pincode,
  //   pinCode,
  //   lat,
  //   lon,
  //   fullAddress,
  // ]);

  // ==========================================================
  // SAFE LOCATION OPTIONS
  // ==========================================================

  const safeLocationOptions = useMemo(() => {
    return {
      cities: Array.isArray(locationOptions?.cities)
        ? locationOptions.cities
        : [],

      areas: Array.isArray(locationOptions?.areas) ? locationOptions.areas : [],

      postalCodes: Array.isArray(locationOptions?.postalCodes)
        ? locationOptions.postalCodes
        : [],
    };
  }, [locationOptions]);

  // ==========================================================
  // SAFE SUGGESTIONS
  // ==========================================================

  const suggestions = useMemo(() => {
    if (Array.isArray(reduxSuggestions)) {
      return reduxSuggestions;
    }

    if (Array.isArray(reduxSuggestions?.users)) {
      return reduxSuggestions.users;
    }

    if (Array.isArray(reduxSuggestions?.results)) {
      return reduxSuggestions.results;
    }

    if (Array.isArray(reduxSuggestions?.data)) {
      return reduxSuggestions.data;
    }

    return [];
  }, [reduxSuggestions]);

  // ==========================================================
  // LOCAL STATE
  // ==========================================================

  const [manualMode, setManualMode] = useState(false);

  const [selectedCity, setSelectedCity] = useState("");

  const [selectedArea, setSelectedArea] = useState("");

  const [selectedPincode, setSelectedPincode] = useState("");

  const [searchInput, setSearchInput] = useState("");

  const [locationOptionsLoaded, setLocationOptionsLoaded] = useState(false);

  const [locationOptionsLoading, setLocationOptionsLoading] = useState(false);

  const [searching, setSearching] = useState(false);

  // ==========================================================
  // CURRENT POSTAL CODE
  // ==========================================================

  const currentPostcode =
    selectedPincode || postcode || postalCode || pincode || pinCode || "";

  // ==========================================================
  // CURRENT CITY
  // ==========================================================

  const currentCity = selectedCity || city || "";

  // ==========================================================
  // CURRENT AREA
  // ==========================================================

  const currentArea = selectedArea || village || area || locality || "";

  // ==========================================================
  // LOCATION DISPLAY
  // ==========================================================

  const displayLocation = useMemo(() => {
    if (fullAddress) {
      return fullAddress;
    }

    const parts = [
      currentArea,
      currentCity,
      district,
      state,
      currentPostcode,
      country,
    ].filter(
      (value) =>
        value !== undefined && value !== null && String(value).trim() !== "",
    );

    if (parts.length > 0) {
      return parts.join(", ");
    }

    return "Select location";
  }, [
    fullAddress,
    currentArea,
    currentCity,
    district,
    state,
    currentPostcode,
    country,
  ]);

  // ==========================================================
  // HAS LOCATION
  // ==========================================================

  const hasLocation = useMemo(() => {
    return Boolean(
      fullAddress ||
      currentArea ||
      currentCity ||
      district ||
      state ||
      currentPostcode ||
      country,
    );
  }, [
    fullAddress,
    currentArea,
    currentCity,
    district,
    state,
    currentPostcode,
    country,
  ]);

  // ==========================================================
  // FETCH SEARCH SUGGESTIONS
  // ==========================================================

  useEffect(() => {
    const query = searchInput.trim();

    if (query.length < 2) {
      dispatch(
        fetchSuggestions({
          q: null,
        }),
      );

      return;
    }

    const timer = setTimeout(() => {
      const payload = {
        q: query,

        lat: lat !== undefined && lat !== null && lat !== "" ? lat : undefined,

        lon: lon !== undefined && lon !== null && lon !== "" ? lon : undefined,
      };

      console.log("🔎 FETCH SUGGESTIONS:", payload);

      dispatch(fetchSuggestions(payload))
        .unwrap()
        .then((result) => {
          console.log("✅ Suggestions:", result);
        })
        .catch((error) => {
          console.error("❌ Suggestion error:", error);
        });
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [searchInput, lat, lon, dispatch]);

  // ==========================================================
  // CLICK OUTSIDE
  // ==========================================================

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        dispatch(
          fetchSuggestions({
            q: null,
          }),
        );
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);

  // ==========================================================
  // OPEN LOCATION POPUP
  // ==========================================================

  const openLocationPopup = () => {
    setManualMode(true);

    setSelectedCity(city || "");

    setSelectedArea(village || area || locality || "");

    setSelectedPincode(postcode || postalCode || pincode || pinCode || "");

    setLocationOptionsLoaded(false);

    console.log("📍 LOCATION POPUP OPENED");

    console.log("Current City:", city);

    console.log("Current Area:", village || area || locality);

    console.log(
      "Current Pincode:",
      postcode || postalCode || pincode || pinCode,
    );
  };

  // ==========================================================
  // CLOSE LOCATION POPUP
  // ==========================================================

  const closeLocationPopup = () => {
    setManualMode(false);

    setSelectedCity("");
    setSelectedArea("");
    setSelectedPincode("");
  };

  // ==========================================================
  // LOAD LOCATION OPTIONS
  // ==========================================================

  const handleLocationDropdownOpen = async () => {
    if (locationOptionsLoaded || locationOptionsLoading) {
      return;
    }

    try {
      setLocationOptionsLoading(true);

      console.log("📍 Loading registered location options...");

      const result = await dispatch(fetchLocationOptions()).unwrap();

      console.log("✅ LOCATION OPTIONS RECEIVED:", result);

      console.log("🏙️ Cities:", result?.cities);

      console.log("📍 Areas:", result?.areas);

      console.log("📮 Postal Codes:", result?.postalCodes);

      setLocationOptionsLoaded(true);
    } catch (error) {
      console.error("❌ Location options error:", error);
    } finally {
      setLocationOptionsLoading(false);
    }
  };

  // ==========================================================
  // FILTER AREAS
  // ==========================================================

  const filteredAreas = useMemo(() => {
    return safeLocationOptions.areas.filter((areaItem) => {
      if (!selectedCity) {
        return true;
      }

      if (typeof areaItem === "string") {
        return true;
      }

      const itemCity = areaItem.city || areaItem.town || areaItem.municipality;

      if (!itemCity) {
        return true;
      }

      return (
        String(itemCity).toLowerCase() === String(selectedCity).toLowerCase()
      );
    });
  }, [safeLocationOptions.areas, selectedCity]);

  // ==========================================================
  // FILTER PINCODES
  // ==========================================================

  const filteredPincodes = useMemo(() => {
    return safeLocationOptions.postalCodes.filter((code) => {
      // ----------------------------------------------
      // STRING PINCODE
      // ----------------------------------------------

      if (typeof code === "string") {
        return true;
      }

      if (!code || typeof code !== "object") {
        return false;
      }

      // ----------------------------------------------
      // SUPPORT ALL POSSIBLE FIELD NAMES
      // ----------------------------------------------

      const codeArea =
        code.area || code.village || code.locality || code.suburb || "";

      const codeCity = code.city || code.town || code.municipality || "";

      // ----------------------------------------------
      // AREA + CITY FILTER
      // ----------------------------------------------

      if (selectedArea && codeArea) {
        const areaMatches =
          String(codeArea).trim().toLowerCase() ===
          String(selectedArea).trim().toLowerCase();

        if (!areaMatches) {
          return false;
        }

        if (selectedCity && codeCity) {
          return (
            String(codeCity).trim().toLowerCase() ===
            String(selectedCity).trim().toLowerCase()
          );
        }

        return true;
      }

      // ----------------------------------------------
      // CITY FILTER
      // ----------------------------------------------

      if (selectedCity && codeCity) {
        return (
          String(codeCity).trim().toLowerCase() ===
          String(selectedCity).trim().toLowerCase()
        );
      }

      return true;
    });
  }, [safeLocationOptions.postalCodes, selectedCity, selectedArea]);

  // ==========================================================
  // DEBUG PINCODE OPTIONS
  // ==========================================================

  useEffect(() => {
    if (!manualMode) {
      return;
    }

    console.log("========================================");

    console.log("📮 PINCODE DEBUG");

    console.log("========================================");

    console.log("Selected City:", selectedCity);

    console.log("Selected Area:", selectedArea);

    console.log("All Postal Codes:", safeLocationOptions.postalCodes);

    console.log("Filtered Postal Codes:", filteredPincodes);

    console.log("========================================");
  }, [
    manualMode,
    selectedCity,
    selectedArea,
    safeLocationOptions.postalCodes,
    filteredPincodes,
  ]);

  // ==========================================================
  // SEARCH API
  // ==========================================================

  const performSearch = async (payload) => {
    try {
      setSearching(true);

      console.log("🔎 SEARCH PAYLOAD:", payload);

      const result = await dispatch(searchUsers(payload)).unwrap();

      console.log("✅ SEARCH SUCCESS:", result);

      return result;
    } catch (error) {
      console.error("❌ SEARCH ERROR:", error);

      return null;
    } finally {
      setSearching(false);
    }
  };

  // ==========================================================
  // APPLY LOCATION
  // ==========================================================

  const applyLocation = async () => {
    const selectedCityValue = selectedCity.trim();

    const selectedAreaValue = selectedArea.trim();

    const selectedPincodeValue = selectedPincode.trim();

    if (!selectedCityValue && !selectedAreaValue && !selectedPincodeValue) {
      alert("Please select or enter a city, area or pincode.");

      return;
    }

    // ----------------------------------------------
    // PINCODE VALIDATION
    // ----------------------------------------------

    if (selectedPincodeValue && !/^\d{6}$/.test(selectedPincodeValue)) {
      alert("Please enter a valid 6-digit pincode.");

      return;
    }

    const locationText = [
      selectedAreaValue,
      selectedCityValue,
      selectedPincodeValue,
    ]
      .filter(Boolean)
      .join(", ");

    // ----------------------------------------------
    // SAVE MANUAL LOCATION TO REDUX
    // ----------------------------------------------

    const manualLocation = {
      country: country || "India",

      state: state || "",

      district: district || "",

      city: selectedCityValue,

      village: selectedAreaValue,

      area: selectedAreaValue,

      locality: selectedAreaValue,

      postcode: selectedPincodeValue,

      postalCode: selectedPincodeValue,

      pincode: selectedPincodeValue,

      pinCode: selectedPincodeValue,

      fullAddress: locationText,

      lat: lat !== undefined && lat !== null && lat !== "" ? lat : null,

      lon: lon !== undefined && lon !== null && lon !== "" ? lon : null,

      isManual: true,
    };

    console.log("📍 MANUAL LOCATION:", manualLocation);

    dispatch(setManualLocation(manualLocation));

    // ----------------------------------------------
    // SEARCH PAYLOAD
    // ----------------------------------------------

    const payload = {
      input: searchInput.trim() || undefined,

      city: selectedCityValue || undefined,

      village: selectedAreaValue || undefined,

      area: selectedAreaValue || undefined,

      postalCode: selectedPincodeValue || undefined,

      postcode: selectedPincodeValue || undefined,

      pincode: selectedPincodeValue || undefined,

      country: country || "India",

      state: state || undefined,

      district: district || undefined,

      lat: lat !== undefined && lat !== null && lat !== "" ? lat : undefined,

      lon: lon !== undefined && lon !== null && lon !== "" ? lon : undefined,
    };

    console.log("📍 APPLY LOCATION:", locationText);

    console.log("📍 APPLY LOCATION PAYLOAD:", payload);

    await performSearch(payload);

    setManualMode(false);
  };

  // ==========================================================
  // MAIN SEARCH
  // ==========================================================

  const handleSearch = async () => {
    const input = searchInput.trim();

    if (!input) {
      alert(
        "Search by doctor name, username, phone, email, profession or service.",
      );

      inputRef.current?.focus();

      return;
    }

    const selectedCurrentPincode =
      selectedPincode.trim() ||
      postcode ||
      postalCode ||
      pincode ||
      pinCode ||
      "";

    const payload = {
      input,

      city: selectedCity.trim() || city || undefined,

      village: selectedArea.trim() || village || area || locality || undefined,

      area: selectedArea.trim() || area || locality || undefined,

      postalCode: selectedCurrentPincode || undefined,

      postcode: selectedCurrentPincode || undefined,

      pincode: selectedCurrentPincode || undefined,

      country: country || "India",

      state: state || undefined,

      district: district || undefined,

      lat: lat !== undefined && lat !== null && lat !== "" ? lat : undefined,

      lon: lon !== undefined && lon !== null && lon !== "" ? lon : undefined,
    };

    console.log("🔎 MAIN SEARCH PAYLOAD:", payload);

    await performSearch(payload);

    dispatch(
      fetchSuggestions({
        q: null,
      }),
    );
  };

  // ==========================================================
  // SELECT SUGGESTION
  // ==========================================================

  const handleSelectUser = async (item) => {
    if (!item) {
      return;
    }

    console.log("👤 SELECTED USER:", item);

    console.log("📍 SELECTED USER LOCATION:", {
      country: item.country,

      state: item.state,

      district: item.district,

      city: item.city,

      area: item.area || item.village || item.locality,

      pincode: item.postalCode || item.postcode || item.pincode || item.pinCode,
    });

    setSearchInput(item.fullName || item.name || item.username || "");

    dispatch(setSelectedUser(item));

    dispatch(
      fetchSuggestions({
        q: null,
      }),
    );
  };

  // ==========================================================
  // CLEAR SEARCH
  // ==========================================================

  const clearSearchInput = () => {
    setSearchInput("");

    dispatch(
      fetchSuggestions({
        q: null,
      }),
    );

    inputRef.current?.focus();
  };

  // ==========================================================
  // SHOW SUGGESTIONS
  // ==========================================================

  const showSuggestions =
    searchInput.trim().length >= 2 && suggestions.length > 0;

  // ==========================================================
  // UI
  // ==========================================================

  return (
    <div
      ref={wrapperRef}
      className="
        relative
        w-full
        max-w-5xl
        mx-auto
        px-1
        sm:px-2
      "
    >
      {/* =====================================================
          SEARCH CONTAINER
      ===================================================== */}

      <div className="relative w-full">
        {/* ===================================================
            SEARCH INPUT
        =================================================== */}

        <div
          className="
            relative
            overflow-hidden
            rounded-2xl
            border
            border-white/20
            shadow-xl
          "
          style={{
            background: "rgba(255,255,255,0.97)",
          }}
        >
          <div
            className="
              absolute
              left-0
              top-0
              bottom-0
              w-1
            "
            style={{
              background: BUTTON_GRADIENT,
            }}
          />

          <MagnifyingGlassIcon
            className="
              absolute
              left-4
              sm:left-5
              top-1/2
              -translate-y-1/2
              w-5
              h-5
              sm:w-6
              sm:h-6
              pointer-events-none
            "
            style={{
              color: TEXT_MUTED,
            }}
          />

          <input
            ref={inputRef}
            type="text"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }

              if (e.key === "Escape") {
                dispatch(
                  fetchSuggestions({
                    q: null,
                  }),
                );
              }
            }}
            placeholder="Search doctor, username, phone, email, hospital, clinic..."
            className="
              w-full
              h-12
              sm:h-14
              md:h-16
              pl-12
              sm:pl-14
              pr-24
              sm:pr-28
              text-xs
              sm:text-sm
              md:text-base
              font-medium
              bg-transparent
              focus:outline-none
            "
            style={{
              color: "rgb(30,41,59)",
            }}
          />

          {/* =================================================
              CLEAR BUTTON
          ================================================= */}

          {searchInput && (
            <button
              type="button"
              onClick={clearSearchInput}
              className="
                absolute
                right-14
                sm:right-16
                top-1/2
                -translate-y-1/2
                w-7
                h-7
                flex
                items-center
                justify-center
                rounded-full
                transition
              "
              style={{
                color: "rgb(148,163,184)",
              }}
            >
              <XMarkIcon
                className="
                  w-4
                  h-4
                "
              />
            </button>
          )}

          {/* =================================================
              SEARCH BUTTON
          ================================================= */}

          <button
            type="button"
            onClick={handleSearch}
            disabled={searching}
            className="
              absolute
              right-2
              top-1/2
              -translate-y-1/2
              flex
              items-center
              justify-center
              gap-2
              w-10
              h-10
              sm:w-12
              sm:h-12
              rounded-xl
              text-white
              shadow-lg
              hover:scale-[1.03]
              active:scale-95
              transition-all
              disabled:opacity-60
            "
            style={{
              background: BUTTON_GRADIENT,
            }}
          >
            <MagnifyingGlassIcon
              className="
                w-5
                h-5
              "
            />
          </button>
        </div>

        {/* =================================================
            SUGGESTION CARDS
        ================================================= */}

        {showSuggestions && (
          <div
            className="
              absolute
              left-0
              right-0
              z-[80]
              mt-2
              overflow-hidden
              rounded-2xl
              border
              shadow-[0_20px_60px_rgba(15,31,51,0.25)]
            "
            style={{
              background: "rgb(255,255,255)",
              borderColor: "rgb(226,232,240)",
            }}
          >
            {/* HEADER */}

            <div
              className="
                px-4
                sm:px-5
                py-3
                border-b
                flex
                items-center
                justify-between
              "
              style={{
                background: "rgb(248,250,252)",
                borderColor: "rgb(241,245,249)",
              }}
            >
              <div>
                <p
                  className="
                    text-[10px]
                    sm:text-xs
                    font-bold
                    uppercase
                    tracking-wider
                  "
                  style={{
                    color: TEXT_MUTED,
                  }}
                >
                  Search Results
                </p>

                <p
                  className="
                    text-sm
                    font-semibold
                    mt-0.5
                  "
                  style={{
                    color: "rgb(30,41,59)",
                  }}
                >
                  {suggestions.length} matching{" "}
                  {suggestions.length === 1 ? "profile" : "profiles"}
                </p>
              </div>

              <div
                className="
                  flex
                  items-center
                  justify-center
                  w-9
                  h-9
                  rounded-xl
                "
                style={{
                  background: "rgba(14,165,233,0.10)",
                }}
              >
                <UserIcon
                  className="
                    w-5
                    h-5
                  "
                  style={{
                    color: PRIMARY_BLUE,
                  }}
                />
              </div>
            </div>

            {/* RESULTS */}

            <div
              className="
                max-h-[65vh]
                overflow-y-auto
                overscroll-contain
              "
            >
              {suggestions.map((item, index) => {
                const userName =
                  item.fullName ||
                  item.name ||
                  item.username ||
                  "Healthcare Professional";

                const profession =
                  item.profession || item.designation || item.role;

                const category = Array.isArray(item.categoryPath)
                  ? item.categoryPath.join("  ›  ")
                  : item.category || item.specialization || "";

                // =================================================
                // USER LOCATION
                // =================================================

                const userArea =
                  item.village ||
                  item.area ||
                  item.locality ||
                  item.suburb ||
                  "";

                const userPincode =
                  item.postalCode ||
                  item.postcode ||
                  item.pincode ||
                  item.pinCode ||
                  "";

                const location = [
                  userArea,
                  item.city || item.town || item.municipality,

                  item.district,

                  item.state,

                  userPincode,

                  item.country,
                ]
                  .filter(
                    (value) =>
                      value !== undefined &&
                      value !== null &&
                      String(value).trim() !== "",
                  )
                  .join(", ");

                return (
                  <button
                    type="button"
                    key={item._id || item.id || `${userName}-${index}`}
                    onClick={() => handleSelectUser(item)}
                    className="
                        group
                        relative
                        w-full
                        text-left
                        px-3
                        sm:px-4
                        py-3
                        border-b
                        transition-all
                        duration-200
                        hover:bg-slate-50
                      "
                    style={{
                      borderColor: "rgb(241,245,249)",
                    }}
                  >
                    <div className="flex gap-3">
                      {/* AVATAR */}

                      <div
                        className="
                            flex-shrink-0
                            w-11
                            h-11
                            sm:w-12
                            sm:h-12
                            rounded-xl
                            flex
                            items-center
                            justify-center
                            text-white
                            shadow-md
                            overflow-hidden
                          "
                        style={{
                          background: BUTTON_GRADIENT,
                        }}
                      >
                        {item.profilePhoto ||
                        item.profileImage ||
                        item.photo ||
                        item.image ? (
                          <img
                            src={
                              item.profilePhoto ||
                              item.profileImage ||
                              item.photo ||
                              item.image
                            }
                            alt={userName}
                            className="
                                w-full
                                h-full
                                object-cover
                              "
                          />
                        ) : (
                          <UserIcon
                            className="
                                w-6
                                h-6
                              "
                          />
                        )}
                      </div>

                      {/* CONTENT */}

                      <div
                        className="
                            min-w-0
                            flex-1
                          "
                      >
                        {/* NAME */}

                        <div
                          className="
                              flex
                              items-center
                              gap-2
                            "
                        >
                          <p
                            className="
                                text-sm
                                sm:text-base
                                font-bold
                                truncate
                              "
                            style={{
                              color: "rgb(30,41,59)",
                            }}
                          >
                            {userName}
                          </p>

                          <ChevronRightIcon
                            className="
                                flex-shrink-0
                                w-4
                                h-4
                              "
                            style={{
                              color: "rgb(203,213,225)",
                            }}
                          />
                        </div>

                        {/* PROFESSION */}

                        {profession && (
                          <div
                            className="
                                flex
                                items-center
                                gap-1.5
                                mt-1
                              "
                          >
                            <BuildingOffice2Icon
                              className="
                                  w-3.5
                                  h-3.5
                                  flex-shrink-0
                                "
                              style={{
                                color: PRIMARY_BLUE,
                              }}
                            />

                            <p
                              className="
                                  text-xs
                                  sm:text-sm
                                  font-medium
                                  truncate
                                "
                              style={{
                                color: TEXT_MUTED,
                              }}
                            >
                              {profession}
                            </p>
                          </div>
                        )}

                        {/* CATEGORY */}

                        {category && (
                          <div
                            className="
                                inline-flex
                                max-w-full
                                mt-1.5
                                px-2
                                py-0.5
                                rounded-md
                                border
                              "
                            style={{
                              background: PRIMARY_LIGHT,
                              borderColor: BORDER_COLOR,
                            }}
                          >
                            <p
                              className="
                                  text-[10px]
                                  sm:text-xs
                                  font-semibold
                                  truncate
                                "
                              style={{
                                color: PRIMARY_DARK,
                              }}
                            >
                              {category}
                            </p>
                          </div>
                        )}

                        {/* USERNAME */}

                        {item.username && (
                          <p
                            className="
                                text-[10px]
                                sm:text-xs
                                mt-1
                                truncate
                              "
                            style={{
                              color: "rgb(148,163,184)",
                            }}
                          >
                            @{item.username}
                          </p>
                        )}

                        {/* PHONE + EMAIL */}

                        <div
                          className="
                              flex
                              flex-wrap
                              gap-x-4
                              gap-y-1
                              mt-1.5
                            "
                        >
                          {item.phone && (
                            <div
                              className="
                                  flex
                                  items-center
                                  gap-1
                                  min-w-0
                                "
                            >
                              <PhoneIcon
                                className="
                                    w-3
                                    h-3
                                    flex-shrink-0
                                  "
                                style={{
                                  color: "rgb(148,163,184)",
                                }}
                              />

                              <span
                                className="
                                    text-[10px]
                                    sm:text-xs
                                    truncate
                                  "
                                style={{
                                  color: TEXT_MUTED,
                                }}
                              >
                                {item.phone}
                              </span>
                            </div>
                          )}

                          {item.email && (
                            <div
                              className="
                                  flex
                                  items-center
                                  gap-1
                                  min-w-0
                                "
                            >
                              <EnvelopeIcon
                                className="
                                    w-3
                                    h-3
                                    flex-shrink-0
                                  "
                                style={{
                                  color: "rgb(148,163,184)",
                                }}
                              />

                              <span
                                className="
                                    text-[10px]
                                    sm:text-xs
                                    truncate
                                  "
                                style={{
                                  color: TEXT_MUTED,
                                }}
                              >
                                {item.email}
                              </span>
                            </div>
                          )}
                        </div>

                        {/* LOCATION */}

                        {location && (
                          <div
                            className="
                                flex
                                items-center
                                gap-1
                                mt-1.5
                              "
                          >
                            <MapPinIcon
                              className="
                                  w-3
                                  h-3
                                  flex-shrink-0
                                "
                              style={{
                                color: PRIMARY_BLUE,
                              }}
                            />

                            <span
                              className="
                                  text-[10px]
                                  sm:text-xs
                                  truncate
                                "
                              style={{
                                color: TEXT_MUTED,
                              }}
                              title={location}
                            >
                              {location}
                            </span>
                          </div>
                        )}

                        {/* DISTANCE */}

                        {item.distanceKm !== undefined &&
                          item.distanceKm !== null && (
                            <div
                              className="
                                  mt-1.5
                                  inline-flex
                                  items-center
                                  px-2
                                  py-0.5
                                  rounded-full
                                  border
                                "
                              style={{
                                background: "rgb(236,253,245)",
                                borderColor: "rgb(209,250,229)",
                              }}
                            >
                              <span
                                className="
                                    text-[10px]
                                    sm:text-xs
                                    font-bold
                                  "
                                style={{
                                  color: "rgb(5,150,105)",
                                }}
                              >
                                📍 {item.distanceKm} km away
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* =====================================================
          CURRENT LOCATION
      ===================================================== */}

      {hasLocation && !manualMode && (
        <div
          className="
              mt-2
              flex
              items-center
              justify-between
              gap-3
              px-2
            "
        >
          {/* LOCATION */}

          <div
            className="
                min-w-0
                flex
                items-center
                gap-1.5
                flex-1
              "
          >
            <MapPinIcon
              className="
                  flex-shrink-0
                  w-3.5
                  h-3.5
                "
              style={{
                color: "rgb(125,211,252)",
              }}
            />

            <p
              className="
                  text-[10px]
                  sm:text-xs
                  md:text-sm
                  text-white
                  font-medium
                  truncate
                  px-2
                  py-1
                  rounded-md
                  max-w-full
                "
              style={{
                background: BUTTON_GRADIENT,
              }}
              title={displayLocation}
            >
              {displayLocation}
            </p>
          </div>

          {/* CHANGE BUTTON */}

          <button
            type="button"
            onClick={openLocationPopup}
            className="
                flex-shrink-0
                text-[10px]
                sm:text-xs
                md:text-sm
                font-semibold
                text-white
                px-3
                py-1
                rounded-lg
                shadow-sm
                hover:opacity-90
                transition-all
                duration-200
              "
            style={{
              background: BUTTON_GRADIENT,
            }}
          >
            Change
          </button>
        </div>
      )}

      {/* =====================================================
          LOCATION MODAL
      ===================================================== */}

      {manualMode && (
        <div
          className="
            fixed
            inset-0
            z-[100]
            flex
            items-center
            justify-center
            p-3
            sm:p-5
            backdrop-blur-sm
          "
          style={{
            background: "rgba(2,6,23,0.70)",
          }}
        >
          <div
            className="
              relative
              w-full
              max-w-md
              max-h-[92vh]
              overflow-y-auto
              rounded-3xl
              bg-white
              shadow-[0_30px_100px_rgba(0,0,0,0.35)]
            "
          >
            {/* HEADER */}

            <div
              className="
                relative
                px-5
                sm:px-6
                py-5
                text-white
              "
              style={{
                background: CUSTOM_GRADIENT,
              }}
            >
              <button
                type="button"
                onClick={closeLocationPopup}
                className="
                  absolute
                  top-4
                  right-4
                  w-9
                  h-9
                  flex
                  items-center
                  justify-center
                  rounded-full
                  transition
                "
                style={{
                  background: "rgba(255,255,255,0.10)",
                }}
              >
                <XMarkIcon
                  className="
                    w-5
                    h-5
                  "
                />
              </button>

              <div className="pr-10">
                <div
                  className="
                    inline-flex
                    items-center
                    justify-center
                    w-11
                    h-11
                    rounded-xl
                    mb-3
                  "
                  style={{
                    background: "rgba(255,255,255,0.10)",
                  }}
                >
                  <MapPinIcon
                    className="
                      w-6
                      h-6
                    "
                  />
                </div>

                <h2
                  className="
                    text-lg
                    sm:text-xl
                    font-bold
                  "
                >
                  Change Location
                </h2>

                <p
                  className="
                    text-xs
                    sm:text-sm
                    mt-1
                  "
                  style={{
                    color: "rgb(203,213,225)",
                  }}
                >
                  Select from the list or enter your location manually.
                </p>
              </div>
            </div>

            {/* BODY */}

            <div
              className="
                p-5
                sm:p-6
              "
            >
              {/* INFORMATION */}

              <div
                className="
                  mb-5
                  p-3
                  rounded-2xl
                  border
                "
                style={{
                  background: PRIMARY_LIGHT,
                  borderColor: BORDER_COLOR,
                }}
              >
                <div
                  className="
                    flex
                    items-start
                    gap-2
                  "
                >
                  <MapPinIcon
                    className="
                      w-4
                      h-4
                      mt-0.5
                      flex-shrink-0
                    "
                    style={{
                      color: PRIMARY_BLUE,
                    }}
                  />

                  <div>
                    <p
                      className="
                        text-xs
                        font-bold
                      "
                      style={{
                        color: PRIMARY_DARK,
                      }}
                    >
                      Choose or enter your location
                    </p>

                    <p
                      className="
                        text-[10px]
                        sm:text-xs
                        mt-0.5
                      "
                      style={{
                        color: TEXT_MUTED,
                      }}
                    >
                      You can select an option from the dropdown or type your
                      own value.
                    </p>
                  </div>
                </div>
              </div>

              {/* CITY */}

              <label
                className="
                  block
                  text-xs
                  sm:text-sm
                  font-bold
                  mb-1.5
                "
                style={{
                  color: TEXT_DARK,
                }}
              >
                City
              </label>

              <input
                type="text"
                value={selectedCity}
                onFocus={handleLocationDropdownOpen}
                onChange={(e) => {
                  setSelectedCity(e.target.value);

                  setSelectedArea("");
                  setSelectedPincode("");
                }}
                list="city-options"
                placeholder={
                  locationOptionsLoading
                    ? "Loading cities..."
                    : "Select or enter city"
                }
                autoComplete="off"
                className="
                  w-full
                  h-11
                  px-3
                  rounded-xl
                  border
                  bg-slate-50
                  text-sm
                  focus:outline-none
                  transition
                "
                style={{
                  borderColor: "rgb(226,232,240)",
                  color: "rgb(30,41,59)",
                }}
              />

              <datalist id="city-options">
                {safeLocationOptions.cities.map((cityItem, index) => {
                  const value =
                    typeof cityItem === "string"
                      ? cityItem
                      : cityItem.name || cityItem.city || cityItem.town;

                  if (!value) {
                    return null;
                  }

                  return <option key={`${value}-${index}`} value={value} />;
                })}
              </datalist>

              <p
                className="
                  mt-1
                  text-[10px]
                "
                style={{
                  color: "rgb(148,163,184)",
                }}
              >
                Type manually or choose a city from the suggestions.
              </p>

              {/* AREA */}

              <label
                className="
                  block
                  text-xs
                  sm:text-sm
                  font-bold
                  mb-1.5
                  mt-4
                "
                style={{
                  color: TEXT_DARK,
                }}
              >
                Area / Locality
              </label>

              <input
                type="text"
                value={selectedArea}
                onFocus={handleLocationDropdownOpen}
                onChange={(e) => {
                  setSelectedArea(e.target.value);

                  setSelectedPincode("");
                }}
                list="area-options"
                placeholder="Select or enter area / locality"
                autoComplete="off"
                className="
                  w-full
                  h-11
                  px-3
                  rounded-xl
                  border
                  bg-slate-50
                  text-sm
                  focus:outline-none
                  transition
                "
                style={{
                  borderColor: "rgb(226,232,240)",
                  color: "rgb(30,41,59)",
                }}
              />

              <datalist id="area-options">
                {filteredAreas.map((areaItem, index) => {
                  const value =
                    typeof areaItem === "string"
                      ? areaItem
                      : areaItem.name ||
                        areaItem.village ||
                        areaItem.area ||
                        areaItem.locality;

                  if (!value) {
                    return null;
                  }

                  return <option key={`${value}-${index}`} value={value} />;
                })}
              </datalist>

              <p
                className="
                  mt-1
                  text-[10px]
                "
                style={{
                  color: "rgb(148,163,184)",
                }}
              >
                You can type an area that is not present in the list.
              </p>

              {/* PINCODE */}

              <label
                className="
                  block
                  text-xs
                  sm:text-sm
                  font-bold
                  mb-1.5
                  mt-4
                "
                style={{
                  color: TEXT_DARK,
                }}
              >
                Pincode
              </label>

              <input
                type="text"
                inputMode="numeric"
                value={selectedPincode}
                onFocus={handleLocationDropdownOpen}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 6);

                  setSelectedPincode(value);
                }}
                list="pincode-options"
                placeholder={
                  locationOptionsLoading
                    ? "Loading pincodes..."
                    : "Select or enter pincode"
                }
                autoComplete="off"
                maxLength={6}
                className="
                  w-full
                  h-11
                  px-3
                  rounded-xl
                  border
                  bg-slate-50
                  text-sm
                  focus:outline-none
                  transition
                "
                style={{
                  borderColor: "rgb(226,232,240)",
                  color: "rgb(30,41,59)",
                }}
              />

              {/* PINCODE DATALIST */}

              <datalist id="pincode-options">
                {filteredPincodes.map((code, index) => {
                  const value =
                    typeof code === "string"
                      ? code
                      : code.postalCode ||
                        code.postcode ||
                        code.pincode ||
                        code.pinCode ||
                        code.zipCode;

                  if (!value) {
                    return null;
                  }

                  return (
                    <option key={`${value}-${index}`} value={String(value)} />
                  );
                })}
              </datalist>

              {/* PINCODE DEBUG COUNT */}

              {locationOptionsLoaded && (
                <p
                  className="
                    mt-1
                    text-[10px]
                  "
                  style={{
                    color:
                      filteredPincodes.length > 0
                        ? "rgb(5,150,105)"
                        : "rgb(220,38,38)",
                  }}
                >
                  {filteredPincodes.length > 0
                    ? `${filteredPincodes.length} pincode(s) available`
                    : "No pincode found for the selected location"}
                </p>
              )}

              <p
                className="
                  mt-1
                  text-[10px]
                "
                style={{
                  color: "rgb(148,163,184)",
                }}
              >
                Enter a 6-digit pincode or select one from the list.
              </p>

              {/* LOCATION PREVIEW */}

              {(selectedCity || selectedArea || selectedPincode) && (
                <div
                  className="
                    mt-5
                    p-3
                    rounded-2xl
                    border
                  "
                  style={{
                    background: PRIMARY_LIGHT,
                    borderColor: BORDER_COLOR,
                  }}
                >
                  <div
                    className="
                      flex
                      items-start
                      gap-2
                    "
                  >
                    <MapPinIcon
                      className="
                        w-4
                        h-4
                        mt-0.5
                        flex-shrink-0
                      "
                      style={{
                        color: PRIMARY_BLUE,
                      }}
                    />

                    <div className="min-w-0">
                      <p
                        className="
                          text-[10px]
                          font-bold
                          uppercase
                          tracking-wider
                        "
                        style={{
                          color: PRIMARY_DARK,
                        }}
                      >
                        Searching in
                      </p>

                      <p
                        className="
                          text-xs
                          sm:text-sm
                          font-semibold
                          mt-0.5
                          break-words
                        "
                        style={{
                          color: TEXT_DARK,
                        }}
                      >
                        {[selectedArea, selectedCity, selectedPincode]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* ACTIONS */}

              <div
                className="
                  flex
                  gap-2
                  mt-5
                "
              >
                {/* APPLY */}

                <button
                  type="button"
                  onClick={applyLocation}
                  disabled={searching}
                  className="
                    flex-1
                    h-11
                    rounded-xl
                    text-sm
                    font-bold
                    text-white
                    shadow-lg
                    hover:scale-[1.01]
                    active:scale-95
                    transition
                    disabled:opacity-60
                  "
                  style={{
                    background: BUTTON_GRADIENT,
                  }}
                >
                  {searching ? "Searching..." : "Use This Location"}
                </button>

                {/* CANCEL */}

                <button
                  type="button"
                  onClick={closeLocationPopup}
                  className="
                    px-5
                    h-11
                    rounded-xl
                    border
                    bg-white
                    text-sm
                    font-semibold
                    transition
                  "
                  style={{
                    borderColor: "rgb(226,232,240)",
                    color: TEXT_MUTED,
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* =====================================================
          SELECTED USER MODAL
      ===================================================== */}

      {selectedUser && (
        <div
          className="
            fixed
            inset-0
            z-[110]
            flex
            items-center
            justify-center
            p-3
            sm:p-5
            backdrop-blur-sm
          "
          style={{
            background: "rgba(2,6,23,0.70)",
          }}
        >
          <div
            className="
              relative
              w-full
              max-w-3xl
              max-h-[92vh]
              overflow-y-auto
              rounded-3xl
              bg-white
              shadow-[0_30px_100px_rgba(0,0,0,0.35)]
            "
          >
            {/* MODAL HEADER */}

            <div
              className="
                sticky
                top-0
                z-10
                flex
                items-center
                justify-between
                px-4
                sm:px-6
                py-3
                text-white
              "
              style={{
                background: CUSTOM_GRADIENT,
              }}
            >
              <div
                className="
                  flex
                  items-center
                  gap-2
                "
              >
                <UserIcon
                  className="
                    w-5
                    h-5
                  "
                />

                <span
                  className="
                    text-sm
                    font-bold
                  "
                >
                  Profile Details
                </span>
              </div>

              <button
                type="button"
                onClick={() => dispatch(clearSelectedUser())}
                className="
                  w-8
                  h-8
                  flex
                  items-center
                  justify-center
                  rounded-full
                  transition
                "
                style={{
                  background: "rgba(255,255,255,0.10)",
                }}
              >
                <XMarkIcon
                  className="
                    w-5
                    h-5
                  "
                />
              </button>
            </div>

            {/* USER CARD */}
            <div className="w-full max-w-full min-w-0 overflow-visible p-[clamp(8px,2vw,24px)]">
              <UserCard user={selectedUser} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
